type Environment = "development" | "production";

const env: Environment = import.meta.env.MODE as Environment;

export const config = {
  environment: env,
  isDevelopment: env === "development",
  isProduction: env === "production",

  convex: {
    // Development: https://keen-jackal-905.convex.cloud
    // Production: https://hip-gazelle-676.convex.cloud
    url:
      import.meta.env.VITE_CONVEX_URL ||
      "https://keen-jackal-905.convex.cloud", // Fallback to dev URL
  },

  api: {
    // Longer timeout in development for debugging
    timeout: env === "development" ? 30000 : 10000,
    // Enable detailed logging in development
    enableLogging: env === "development",
  },

  // App-specific configuration
  app: {
    // Default device serial (can be overridden)
    defaultDeviceSerial: "F4GDX1WJ0GQJ",
    // Pagination
    itemsPerPage: 20,
  },
} as const;

export type Config = typeof config;
